/* Versão DE de he-produto.js (só a página de produto).
   A secção DE leva data-he-init="1" para que he-produto.js a ignore; os carrosséis continuam com he-produto.js. */
(function () {
  function pad(n) { return String(n).padStart(2, '0'); }

  function initProduct(root) {
    if (root.dataset.heDeInit) return;
    root.dataset.heDeInit = '1';

    // Galeria
    var slides = root.querySelector('.he-pp__slides');
    var thumbs = root.querySelectorAll('.he-pp__thumb');
    function setActive(i) { thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); }); }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = +t.dataset.index;
        slides.scrollTo({ left: slides.clientWidth * i, behavior: 'smooth' });
        setActive(i);
      });
    });
    if (slides) slides.addEventListener('scroll', function () { setActive(Math.round(slides.scrollLeft / slides.clientWidth)); }, { passive: true });

    // Packs
    var bundle = root.querySelector('[data-bundle]');
    if (bundle) {
      var packs = bundle.querySelectorAll('.he-bundle__pack');
      packs.forEach(function (p) {
        p.querySelector('input').addEventListener('change', function () {
          packs.forEach(function (x) { x.classList.toggle('is-selected', x === p); });
          bundle.querySelectorAll('.is-missing').forEach(function (m) { m.classList.remove('is-missing'); });
          var e3 = root.querySelector('.he-pp__error'); if (e3) e3.hidden = true;
        });
      });

      var modal = bundle.querySelector('[data-modal]');
      var activeSlot = null;
      document.body.appendChild(modal);

      // Pré-carrega as miniaturas do seletor para que abra sem esperas
      var warmed = false;
      var warm = function () {
        if (warmed) return;
        warmed = true;
        modal.querySelectorAll('img[data-he-thumb]').forEach(function (img) { img.loading = 'eager'; });
      };
      if (document.readyState === 'complete') setTimeout(warm, 1200);
      else window.addEventListener('load', function () { setTimeout(warm, 1200); });
      bundle.addEventListener('pointerdown', function (e) { if (e.target.closest('[data-pick]')) warm(); }, { passive: true });
      bundle.addEventListener('touchstart', function (e) { if (e.target.closest('[data-pick]')) warm(); }, { passive: true });
      var closeModal = function () { modal.hidden = true; document.documentElement.style.overflow = ''; activeSlot = null; };
      bundle.querySelectorAll('[data-pick]').forEach(function (b) {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          activeSlot = b.closest('.he-bundle__slot');
          modal.hidden = false;
          document.documentElement.style.overflow = 'hidden';
        });
      });
      modal.addEventListener('click', function (e) { if (e.target === modal || e.target.closest('[data-close]')) closeModal(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) closeModal(); });
      var search = modal.querySelector('[data-search]');
      if (search) search.addEventListener('input', function () {
        var q = search.value.toLowerCase().trim();
        modal.querySelectorAll('.he-bundle__modal-item').forEach(function (it) { it.hidden = !!q && it.dataset.title.indexOf(q) === -1; });
      });
      modal.querySelectorAll('[data-choose]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (!activeSlot) return;
          activeSlot.dataset.variant = b.dataset.choose;
          activeSlot.classList.add('is-filled');
          var img = activeSlot.querySelector('.he-bundle__slot-img');
          img.classList.remove('he-bundle__slot-img--empty');
          var listImg = b.closest('.he-bundle__modal-item').querySelector('img');
          var src = listImg && listImg.currentSrc ? listImg.currentSrc : b.dataset.img;
          img.innerHTML = '<img src="' + src + '" alt="" decoding="async">';
          var t = activeSlot.querySelector('.he-bundle__slot-title');
          t.textContent = b.dataset.title;
          t.hidden = false;
          activeSlot.querySelector('[data-pick]').textContent = 'Ändern';
          activeSlot.classList.remove('is-missing');
          var e2 = root.querySelector('.he-pp__error');
          if (e2 && !bundle.querySelector('.he-bundle__pack.is-selected .he-bundle__slot.is-missing')) e2.hidden = true;
          closeModal();
        });
      });

      var timerEl = bundle.querySelector('[data-cutoff]');
      if (timerEl) {
        var out = timerEl.querySelector('[data-timer]');
        var cutoff = +timerEl.dataset.cutoff;
        var tick = function () {
          var now = new Date(), end = new Date(now);
          end.setHours(cutoff, 0, 0, 0);
          if (end <= now) end.setDate(end.getDate() + 1);
          var s = Math.floor((end - now) / 1000);
          out.textContent = pad(Math.floor(s / 3600)) + ' : ' + pad(Math.floor(s % 3600 / 60)) + ' : ' + pad(s % 60);
        };
        tick(); setInterval(tick, 1000);
      }
    }

    // In den Warenkorb
    var btn = root.querySelector('[data-atc]');
    if (btn) {
      var err = root.querySelector('.he-pp__error');
      btn.addEventListener('click', function () {
        var counts = {};
        var sel = bundle && bundle.querySelector('.he-bundle__pack.is-selected');
        var slots = sel ? sel.querySelectorAll('.he-bundle__slot') : [];

        // Pack incompleto: não deixa adicionar e mostra o que falta
        if (bundle && bundle.dataset.require === 'true' && slots.length) {
          var missing = Array.prototype.filter.call(slots, function (s) { return !s.dataset.variant; });
          if (missing.length) {
            missing.forEach(function (s) {
              s.classList.remove('is-missing'); void s.offsetWidth; s.classList.add('is-missing');
            });
            if (err) { err.textContent = bundle.dataset.requireMsg || 'Bitte wähle alle Kalender deines Pakets aus.'; err.hidden = false; }
            missing[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
          }
        }
        if (slots.length) {
          // Só adiciona os calendários escolhidos; os espaços vazios são ignorados
          slots.forEach(function (s) { var id = s.dataset.variant; if (!id) return; counts[id] = (counts[id] || 0) + 1; });
          if (!Object.keys(counts).length) counts[btn.dataset.variant] = 1;
        } else {
          counts[btn.dataset.variant] = 1;
        }
        var items = Object.keys(counts).map(function (id) { return { id: +id, quantity: counts[id] }; });
        btn.classList.add('is-loading'); btn.disabled = true; if (err) err.hidden = true;
        var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        fetch(base + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
          .then(function () {
            if (btn.dataset.redirect !== 'checkout' && window.HECart) {
              btn.classList.remove('is-loading'); btn.disabled = false;
              window.HECart.open();
              document.dispatchEvent(new CustomEvent('cart:build'));
            } else {
              window.location.href = base + (btn.dataset.redirect === 'checkout' ? 'checkout' : 'cart');
            }
          })
          .catch(function (e) {
            if (err) { err.textContent = (e && (e.description || e.message)) || 'Der Artikel konnte nicht in den Warenkorb gelegt werden. Bitte versuche es erneut.'; err.hidden = false; }
            btn.classList.remove('is-loading'); btn.disabled = false;
          });
      });

      var sticky = root.querySelector('[data-sticky]');
      if (sticky && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (e) {
          sticky.classList.toggle('is-visible', !e[0].isIntersecting && e[0].boundingClientRect.top < 0);
        }).observe(btn);
        sticky.querySelector('[data-sticky-btn]').addEventListener('click', function () { btn.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
      }
    }

    // Versanddatum: "Dienstag, 27. Oktober"
    // Sempre o dia seguinte; se esse dia cair ao fim de semana (pedido à sexta ou ao sábado), passa para segunda. Sem feriados.
    var days = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
    var months = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
    root.querySelectorAll('[data-ship-date]').forEach(function (el) {
      var d = new Date(); d.setDate(d.getDate() + 1);
      while (d.getDay() === 0 || d.getDay() === 6) d.setDate(d.getDate() + 1);
      el.textContent = days[d.getDay()] + ', ' + d.getDate() + '. ' + months[d.getMonth()];
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.he-pp[data-lang="de"]').forEach(initProduct);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
